import {EDocumentType, EPaymentType} from 'src/containers/User';

import {EFormStep, ELeadClientCreatingError} from '../definitions';

export default {
  errors: {
    [ELeadClientCreatingError.TAX_NUMBER_ALREADY_IN_USE]:
      'Профиль с таким ИНН и контактным лицом уже существует.',
    [ELeadClientCreatingError.EMAIL_ALREADY_IN_USE]:
      'Email уже используется. Укажите другой email.',
  },
  labels: {
    companyName: 'Название организации',
    taxNumber: 'ИНН',
    vatNumber: 'VAT number',
    binNumber: 'Бизнес-идентификационный номер (БИН)',
    blrTaxNumber: 'УНП / ИНН',
    ogrn: 'ОГРН/ОГРНИП',
    countryCode: 'Страна',
    currencyCode: 'Валюта',
    resellerId: 'Юрисдикция',
    contactName: 'ФИО контактного лица',
    phone: 'Телефон',
    company: 'Компания',
    responsibleManagerId: 'Ответственный менеджер edna',
    channel: 'Канал',
    tariff: 'Тариф',
    special: 'Индивидуальный',
    tariffConditions: 'Описание условий тарифа',
    documentType: 'Оферта/договор',
    paymentType: 'Тип оплаты',
    manager: 'Ответственный за проверку',
    isChecked: 'Прошел проверку в финансовом и юридическом департаменте',
    depositAmount: 'Размер обеспечительного платежа',
    overdraftAmount: 'Размер овердрафта',
    paymentPeriod: 'Срок оплаты лицензии, дней',
    cancellationPeriod: 'Срок до аннулирования лицензии при неоплате, дней',
    disableBilling: 'Отключить биллинг клиенту',
    contractNumber: 'Номер договора',
    pilotContractNumber: 'Номер договора (опционально)',
    contractDate: 'Дата заключения договора',
    pilotContractDate: 'Действует до',
    partnerId: 'Агент',
    hasPartner: 'Лид от агента',
    bank: 'Банк',
    isAgreedOverdraft: 'Подключение и размер овердрафта согласованы',
    agreedOverdraft: 'Овердрафт согласован с',
    comment: 'Комментарий агента',
  },
  placeholders: {
    email: 'yourname@company.com',
    phone: 'Введите номер',
    currencyCode: 'Выберите валюту',
    resellerId: 'Выберите юрлицо',
    channel: '-',
    tariff: 'Выберите тариф',
    partnerId: 'Выберите агента',
    agreedOverdraft: 'Выберите согласующего',
    managerResponsibleForCheckingId: 'Выберите менеджера',
  },
  buttons: {
    create: 'Создать',
    next: 'Дальше',
    addTariff: 'Добавить тариф',
    confirm: 'Подтверждаю',
    agreed: 'Согласовано',
  },
  titles: {
    dataAndContacts: 'Данные компании и контакты',
    calculationAndLicenses: 'Взаиморасчеты и лицензии',
    companyTariffs: 'Тарифы компании',
  },
  subtitles: {
    commonData: 'Общие данные',
    contacts: 'Контакты',
    paymentSystem: 'Согласованная система оплаты',
    credits: 'Кредитные возможности',
    licensesConditions: 'Условия подключения лицензий',
    proposedCompanyTariffs: 'Создайте доступные тарифы для клиента',
    billing: 'Биллинг',
    contract: 'Договор',
  },
  steps: {
    [EFormStep.DETAILS]: 'Данные компании',
    [EFormStep.CALCULATION_AND_LICENSES]: 'Взаиморасчеты и лицензии',
    [EFormStep.TARIFFS]: 'Тарифы клиента',
  },
  documentTypes: {
    [EDocumentType.AGREEMENT]: {
      label: 'Оферта',
      message:
        'Внимание! Данный тип регистрации доступен для клиента, с которым не подписан бумажный договор. Для работы с сервисом клиент должен будет принять пользовательское соглашение. Подтвердите свой выбор',
    },
    [EDocumentType.CONTRACT]: {
      label: 'Бумажный договор',
      message:
        'Внимание! Данный тип регистрации доступен только для клиента, с которым вы уже подписали договор. Подтвердите свой выбор',
    },
    [EDocumentType.TECH_PARTNER_CONTRACT]: {
      label: 'Техпартнер на договоре',
      message:
        'Внимание! Данный тип регистрации доступен только для клиента, с которым вы уже подписали договор. Подтвердите свой выбор',
    },
    [EDocumentType.TECH_PARTNER_OFFER]: {
      label: 'Техпартнер на оферте',
      message:
        'Внимание! Данный тип регистрации доступен для клиента, с которым не подписан бумажный договор. Для работы с сервисом клиент должен будет принять пользовательское соглашение. Подтвердите свой выбор',
    },
    [EDocumentType.PILOT]: {
      label: 'Пилот',
    },
  },
  hasNoLeadContractPermission:
    'Внимание! Клиентов, которые работают по Бумажному договору, заводят только сотрудники ОТиКДЗ. Лид будет создан после загрузки скана подписанного договора в CRM и отправки запроса на почту <0>{{email}}</0>',
  paymentTypes: {
    [EPaymentType.POSTPAID]: {
      label: 'Постоплата',
    },
    [EPaymentType.PREPAYMENT]: {
      label: 'Предоплата',
    },
    [EPaymentType.MIXED_PREPAYMENT]: {
      label: 'Смешанная оплата',
    },
  },
  error: {
    confirm: 'Необходимо подтвердить',
  },
  billingMessage:
    'Важно! Отключить биллинг можно только клиенту, с которыми заключен договор старого образца. Отключение биллинга должно быть обязательно согласовано с руководителем. Подтвердите свой выбор',
  blrBillingMessage:
    'Клиентам в выбранной юрисдикции биллинг недоступен. Все взаиморасчеты с клиентом производятся на стороне ООО «Инфосинтез».',
};
